module.exports = __webpack_public_path__ + "static/media/webdesign-services-img25.d7a4dd95.jpg";